<template>
  <div class="todo-calendar" v-loading="loading">
    <div ref="calEl" class="todo-calendar__fc" />
  </div>
</template>

<script>
import { Calendar } from '@fullcalendar/core'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import multiMonthPlugin from '@fullcalendar/multimonth'
import zhCnLocale from '@fullcalendar/core/locales/zh-cn'
import { fetchTodoFlatRows } from '@/utils/todoAdapter'

function toFcDate(v) {
  if (!v) return null
  const s = String(v).trim()
  if (!s) return null
  // FullCalendar 接受 ISO / yyyy-MM-dd
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 19).replace(' ', 'T')
  const d = new Date(s)
  if (Number.isNaN(d.getTime())) return null
  const pad = n => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}

export default {
  name: 'TodoCalendar',
  data() {
    return {
      loading: false,
      calendar: null
    }
  },
  mounted() {
    this.initCalendar()
  },
  beforeDestroy() {
    if (this.calendar) {
      this.calendar.destroy()
      this.calendar = null
    }
  },
  activated() {
    if (this.calendar) this.calendar.updateSize()
  },
  methods: {
    async initCalendar() {
      this.loading = true
      let events = []
      try {
        const rows = await fetchTodoFlatRows()
        events = rows
          .map(r => {
            const start = toFcDate(r.receiveDate || r.createDate)
            if (!start) return null
            return {
              id: String(r.id),
              title: r.caseName || r.xmbh || '待办',
              start,
              allDay: true,
              backgroundColor: '#3BB2E3',
              borderColor: '#3BB2E3',
              extendedProps: { route: r.route, row: r }
            }
          })
          .filter(Boolean)
      } catch (e) {
        /* ignore */
      } finally {
        this.loading = false
      }

      const el = this.$refs.calEl
      if (!el) return

      if (this.calendar) {
        this.calendar.destroy()
        this.calendar = null
      }

      this.calendar = new Calendar(el, {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, multiMonthPlugin],
        initialView: 'dayGridMonth',
        firstDay: 1,
        locale: zhCnLocale,
        themeSystem: 'standard',
        headerToolbar: {
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,multiMonthYear,timeGridWeek,timeGridDay,listYear'
        },
        buttonText: {
          today: '今天',
          multiMonthYear: '年',
          dayGridMonth: '月',
          timeGridWeek: '周',
          timeGridDay: '日',
          listYear: '列表'
        },
        allDayText: '全天',
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false
        },
        height: 'auto',
        navLinks: true,
        businessHours: false,
        editable: false,
        selectable: true,
        eventDisplay: 'list-item',
        events,
        eventClick: arg => {
          const route = arg.event.extendedProps && arg.event.extendedProps.route
          if (route) this.$router.push(route)
        }
      })
      this.calendar.render()
    }
  }
}
</script>

<style scoped>
.todo-calendar {
  height: 100%;
  overflow: auto;
  background: #fff;
  padding: 8px 12px 16px;
}
.todo-calendar__fc {
  min-height: 480px;
}
/* Ivan 风格：事件点 + 标题 */
.todo-calendar >>> .fc-event {
  cursor: pointer;
}
.todo-calendar >>> .fc-daygrid-event {
  white-space: normal;
}
</style>
